<template>
  <div class="rightcontent">
    <div class="midContent">
      <div class="content">
        <div ref="webgl" id="webglPano">
          <div class="view-frame">
            <div class="view-btn" @click="saveView">把当前视角设为初始视角</div>
          </div>
        </div>
      </div>
      <BottomBar
        :nowPanoItemIndex="nowPanoActiveIndex"
        :resData="resData"
        :nowFloor="nowFloor"
      ></BottomBar>
    </div>
    <div class="rightBar">
      <div class="right-main">
        <div class="title-line">当前初始视角</div>
        <img :src="viewUrl" class="view-img" />
        <div
          style="
            width: 100%;
            height: 2px;
            border-top: 1px solid rgb(0, 0, 0);
            border-bottom: 1px solid rgb(75, 75, 75);
          "
        ></div>
        <div class="title-line">视角（FOV）范围设置</div>
        <div class="block">
          <div class="slider-block">
            <div class="slider-line">
              <div
                class="blue-line"
                :style="
                  'width:' +
                  (firstx[2] - firstx[0] + 3) +
                  'px;left:' +
                  firstx[0] +
                  'px'
                "
              ></div>
              <div
                class="left-btn"
                :style="'left:' + (firstx[0] - 3) + 'px'"
                @mousedown="moveFirst($event, 0)"
              ></div>
              <div
                class="right-btn"
                :style="'left:' + (firstx[2] - 3) + 'px'"
                @mousedown="moveFirst($event, 2)"
              ></div>
              <div
                class="mid-btn"
                :style="'left:' + (firstx[1] - 5) + 'px'"
                @mousedown="moveFirst($event, 1)"
              ></div>
            </div>
          </div>
          <div class="input-line">
            <div class>
              <input
                type="number"
                class="input-btn"
                v-model="first[0]"
                @keyup.enter="change1(0)"
                @blur="change1(0)"
              />
              <div class="input-label">最近</div>
            </div>
            <div class>
              <input
                type="number"
                class="input-btn"
                v-model="first[1]"
                @keyup.enter="change1(1)"
                @blur="change1(1)"
              />
              <div class="input-label">初始</div>
            </div>
            <div class>
              <input
                type="number"
                class="input-btn"
                v-model="first[2]"
                @keyup.enter="change1(2)"
                @blur="change1(2)"
              />
              <div class="input-label">最远</div>
            </div>
          </div>
        </div>
        <div
          style="
            width: 100%;
            height: 2px;
            border-top: 1px solid rgb(0, 0, 0);
            border-bottom: 1px solid rgb(75, 75, 75);
          "
        ></div>
        <div class="title-line">垂直视角限制</div>
        <div class="block">
          <div class="slider-block">
            <div class="slider-line">
              <div
                class="blue-line"
                :style="
                  'width:' +
                  (secondx[1] - secondx[0] + 3) +
                  'px;left:' +
                  secondx[0] +
                  'px'
                "
              ></div>
              <div
                class="left-btn"
                :style="'left:' + (secondx[0] - 3) + 'px'"
                @mousedown="moveSecond($event, 0)"
              ></div>
              <div
                class="right-btn"
                :style="'left:' + (secondx[1] - 3) + 'px'"
                @mousedown="moveSecond($event, 1)"
              ></div>
            </div>
          </div>
          <div class="input-line">
            <div class>
              <input
                type="number"
                class="input-btn"
                v-model="second[0]"
                @keyup.enter="change2(0)"
                @blur="change2(0)"
              />
              <div class="input-label">最低</div>
            </div>
            <div class>
              <input
                type="number"
                class="input-btn"
                v-model="second[1]"
                @keyup.enter="change2(1)"
                @blur="change2(1)"
              />
              <div class="input-label">最高</div>
            </div>
          </div>
        </div>
        <div
          style="
            width: 100%;
            height: 2px;
            border-top: 1px solid rgb(0, 0, 0);
            border-bottom: 1px solid rgb(75, 75, 75);
          "
        ></div>
        <el-button type="primary" class="reset" @click="reset"
          >恢复默认设置</el-button
        >
        <div
          style="
            width: 100%;
            height: 2px;
            border-top: 1px solid rgb(0, 0, 0);
            border-bottom: 1px solid rgb(75, 75, 75);
          "
        ></div>
        <el-button type="primary" class="reset" @click="saveFovToAll"
          >应用FOV到所有全景</el-button
        >
      </div>
    </div>
    <my-database
      v-if="dialogPic"
      :type="point.type == 3 ? '4' : '5'"
      :closeFunc="closePic"
      :submitFunc="addPic"
    ></my-database>
  </div>
</template>
<style>
.select-list {
  width: 100%;
}
.select-list .el-input__inner {
  width: 100%;
  background-color: #3c3c3c;
  border-color: #525252;
  color: #f7f7f7;
}
.title-input {
  margin: 10px 0 0;
}
.title-input .el-input__inner {
  height: 34px;
  color: #fff;
  background-color: #2c2c2c;
}
</style>
<style scoped>
.rightcontent {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
}
.midContent {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  background-color: #333;
  color: #fff;
  box-sizing: border-box;
}
.content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.content h2 {
  height: 100%;
  text-align: center;
  vertical-align: middle;
  line-height: 100%;
}
.content #webglPano {
  position: absolute;
  top: 20px;
  left: 20px;
  bottom: 20px;
  right: 20px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.7);
  overflow: hidden;
  border-radius: 2px 2px;
}
.rightBar {
  -ms-flex: 0 0 230px;
  flex: 0 0 230px;
  width: 230px;
  position: relative;
  -webkit-box-flex: 0;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  background-color: #333;
  color: #fff;
}
.right-main {
  display: flex;
  flex-flow: column nowrap;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.view-frame {
  height: 330px;
  width: 600px;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: url(/imgs/my/frame.png) no-repeat center;
  background-size: contain;
  z-index: 1000;
}
.view-btn {
  height: 30px;
  width: 200px;
  position: absolute;
  margin: auto;
  bottom: 20px;
  left: 0;
  right: 0;
  background-color: #286efa;
  color: #fff;
  line-height: 30px;
  cursor: pointer;
}
.title-line {
  margin: 30px 15px 20px;
  text-align: left;
}
.view-img {
  height: auto;
  width: 198px;
  margin: 0 auto 30px;
}

/* 滑条 */
.block {
  margin: 0 20px 20px;
}
.slider-block {
  height: 30px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
}
.slider-line {
  height: 5px;
  width: 100%;
  background-color: #2b2b2b;
  border: 1px solid #434343;
}
.left-btn,
.right-btn {
  height: 30px;
  width: 15px;
  position: absolute;
  top: 0;
  background: url(/imgs/my/slider1.png) no-repeat 0 7px;
  background-size: 70%;
  cursor: pointer;
}
.mid-btn {
  height: 15px;
  width: 15px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  background: url(/imgs/my/radio_active.png) no-repeat center;
  background-size: 100%;
  cursor: pointer;
}

.blue-line {
  height: 5px;
  width: 100%;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  background-color: #427afb;
  border: 1px solid #434343;
  box-sizing: border-box;
}

.input-line {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
}

.input-btn {
  height: 18px;
  width: 50px;
  border: 1px solid #434343;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 5px;
  background-color: #2b2b2b;
  color: #aaa;
  text-align: center;
}

.input-label {
  color: #aaa;
}

.reset {
  height: 30px;
  width: 155px;
  margin: 20px auto;
  line-height: 0;
}
</style>
<script>
import BottomBar from '../components/webgl/BottomBar.vue'
import MyDatabase from '../components/database.vue'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader_z'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import https from '../https.js'
let vm = null
const vertexShader = [
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    pPos = position;',
  '    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );',
  '    gl_Position = projectionMatrix * mvPosition;',
  '}'
].join('\n')

const fragmentShader = [
  '#ifdef GL_ES',
  '    precision highp float;',
  '#endif',
  'const float PI = 3.1415926;',
  'const float TWO_PI = 6.2831852;',

  'uniform samplerCube texture;',
  'uniform vec3 cPosition;',
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    vec3 np = normalize(pPos-cPosition);',
  '    gl_FragColor = textureCube( texture, vec3(np.x,np.y,-np.z ));',
  '}'
].join('\n')
export default {
  name: '',
  components: {
    BottomBar,
    MyDatabase
  },
  computed: {
    nowPointActiveIndex: function () {
      return this.panoEditInfos.nowPointActiveIndex
    },
    nowPanoActiveIndex: function () {
      return this.panoEditInfos.nowPanoActiveIndex
    },
    getPanoInfos: function () {
      var arr = []
      if (this.resData.length > 0) {
        return this.resData[this.nowFloor].panos
          ? this.resData[this.nowFloor].panos
          : arr
      } else {
        return arr
      }
    },
    getPointInfos: function () {
      var arr = []
      if (this.resData[this.nowFloor].panos) {
        for (var i = 0; i < this.resData[this.nowFloor].panos.length; i++) {
          if (this.resData[this.nowFloor].panos[i].posX != null) {
            arr.push(this.resData[this.nowFloor].panos[i])
          }
        }
      }
      return arr
    }
  },
  props: ['infos', 'panoEditInfos', 'nowFloor', 'resData'],
  data() {
    return {
      isTopView: true,
      hasInit: false,
      lon: 270,
      lat: 0,

      dialogPic: false,
      viewUrl: '',
      firstx: {
        0: 42,
        1: 68,
        2: 94
      },
      firstCommon: {
        0: 40,
        1: 65,
        2: 90
      },
      first: {
        0: 40,
        1: 65,
        2: 90
      },
      secondx: {
        0: 1,
        1: 188
      },
      secondCommon: {
        0: 1,
        1: 188
      },
      second: {
        0: -90,
        1: 90
      }
    }
  },
  created() {
    document.oncontextmenu = function () {
      return false
    }
    vm = this
  },
  watch: {
    getPanoInfos(val) {
      if (!this.hasInit) {
        if (this.resData.length > 0) {
          this.hasInit = true
          this.generatePano(
            this.panoGroup,
            this.resData[this.nowFloor].panos[this.nowPanoActiveIndex]
          )
        }
      }
    }
  },
  mounted() {
    this.containerUp = null
    this.sceneUp = null
    this.cameraUp = null
    this.meshUp = null
    this.rendererUp = null
    this.containerWUp = 0
    this.containerHUP = 0
    this.targetBoxUp = null
    this.rafId = null
    this.container = null
    this.scene = null
    this.camera = null
    this.mesh = null
    this.renderer = null
    this.controls = null
    this.containerW = 0
    this.containerH = 0
    this.selectionBox = null
    this.transformControls = null
    this.mouse = new THREE.Vector2()
    this.raycaster = new THREE.Raycaster()
    this.onDownPosition = new THREE.Vector2()
    this.onUpPosition = new THREE.Vector2()
    this.pmremGenerator = null
    this.isDown = false
    this.isMoving = false
    this.isModelShow = false
    this.panoGroup = new THREE.Group()
    this.fingers = null
    this.onPointerDownPointerX = 0
    this.onPointerDownPointerY = 0
    this.onPointerDownLon = 0
    this.onPointerDownLat = 0
    this.onPointerDownPointerX0 = 0
    this.onPointerDownPointerY0 = 0
    this.onPointerDownPointerX1 = 0
    this.onPointerDownPointerY1 = 0
    this.preMoveX = 0
    this.preMoveY = 0
    this.offX = 0
    this.offY = 0
    this.disFinger = 0
    this.canDamp = false
    this.dampingFactor = 0.2
    this.targetBox = null
    this.hasLoaded = false
    this.planeUniforms = null
    this.preV = new THREE.Vector2()
    this.textrueLoader = new THREE.TextureLoader()
    this.clock = new THREE.Clock()
    this.init()
    this.animate()
  },
  methods: {
    saveFovToAll() {
      for (var i = 0; i < this.resData[this.nowFloor].panos.length; i++) {
        // this.resData[this.nowFloor].panos[i].lon = this.lon
        // this.resData[this.nowFloor].panos[i].lat = this.lat
        this.resData[this.nowFloor].panos[i].fovMin = this.first[0]
        this.resData[this.nowFloor].panos[i].fovDefault = this.first[1]
        this.resData[this.nowFloor].panos[i].fovMax = this.first[2]
        this.resData[this.nowFloor].panos[i].v_Low = this.second[0]
        this.resData[this.nowFloor].panos[i].v_High = this.second[1]
      }
    },
    init() {
      this.container = this.$refs.webgl
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.scene = new THREE.Scene()
      this.targetBox = new THREE.Mesh(
        new THREE.BoxBufferGeometry(1, 1, 1),
        new THREE.MeshBasicMaterial({
          color: 0xff0000,
          transparent: true,
          opacity: 0
        })
      )
      this.scene.add(this.targetBox)
      this.scene.add(this.panoGroup)
      this.camera = new THREE.PerspectiveCamera(
        this.first[0],
        this.containerW / this.containerH,
        10,
        99999
      )

      this.camera.position.set(0, 0, 0)
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      this.camera.lookAt(this.targetBox.position)
      this.scene.add(this.camera)

      const ambientLight = new THREE.AmbientLight(0xffffff)
      this.scene.add(ambientLight)
      this.planeUniforms = {
        cPosition: { value: new THREE.Vector3() },
        texture: { value: null },
        ...THREE.UniformsLib.lights
      }
      const planeMat = new THREE.ShaderMaterial({
        uniforms: this.planeUniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        lights: true
      })
      planeMat.needsUpdate = true

      if (
        this.resData.length > 0 &&
        this.resData[this.nowFloor].panos.length > 0
      ) {
        this.generatePano(
          this.panoGroup,
          this.resData[this.nowFloor].panos[this.nowPanoActiveIndex]
        )
      }

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      })
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(this.containerW, this.containerH)
      this.container.appendChild(this.renderer.domElement)
      window.addEventListener('resize', this.onresize, false)

      this.container.addEventListener(
        'mousedown',
        this.onRendererMouseDown,
        false
      )
      this.container.addEventListener(
        'mousemove',
        this.onRendererMouseMove,
        false
      )
      this.container.addEventListener('mouseup', this.onRendererMouseUp, false)
      this.container.addEventListener(
        'mousewheel',
        this.onRendererMouseWheel,
        false
      )
    },
    onRendererMouseDown(event) {
      event.preventDefault()
      this.isMoving = false
      this.isDown = true
      this.canDamp = false
      this.preV.x = event.clientX
      this.preV.y = event.clientY
      this.preMoveX = this.onPointerDownPointerX = event.clientX
      this.preMoveY = this.onPointerDownPointerY = event.clientY
      this.onPointerDownLon = this.lon
      this.onPointerDownLat = this.lat
    },
    onRendererMouseMove(event) {
      event.preventDefault()
      this.isMoving = true
      if (this.isDown) {
        this.lon =
          (this.onPointerDownPointerX - event.clientX) * 0.15 +
          this.onPointerDownLon
        const lat =
          (event.clientY - this.onPointerDownPointerY) * 0.15 +
          this.onPointerDownLat
        this.lat = Math.max(this.second[0], Math.min(this.second[1], lat))
        this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
        if (!this.isTopView && this.nowPointActiveIndex !== -1) {
          this.posObj(
            this.targetBoxUp,
            this.cameraUp,
            1,
            this.lon,
            this.lat,
            0
          )
        }
        this.offX = event.clientX - this.preMoveX
        this.offY = event.clientY - this.preMoveY
        this.preMoveX = event.clientX
        this.preMoveY = event.clientY
      }
    },
    onRendererMouseUp(event) {
      const _this = this
      this.isMoving = false
      this.isDown = false
    },
    onRendererMouseWheel() {
      const cameraFovMin = this.first[0]
      const cameraFovMax = this.first[2]
      console.log('wheel:' + cameraFovMin + ',' + cameraFovMax)
      var fov = Math.floor(this.first[1] - event.wheelDeltaY * 0.02)
      if (fov > cameraFovMax) {
        fov = cameraFovMax
      } else if (fov < cameraFovMin) {
        fov = cameraFovMin
      }
      this.first[1] = fov
      this.change1(1)
    },
    cameraUpdate() {
      this.camera.fov = this.first[1]
      this.camera.updateProjectionMatrix()
    },
    changePanoMat(num) {
      const _this = this
      this.$parent.changePanoEditInfos('nowPanoActiveIndex', num)
      var id = this.getPanoInfos[num].id
      var pointNum = this.getPointInfos.findIndex((item) => item.id === id)
      // this.nowPointActiveIndex = pointNum
      this.$parent.changePanoEditInfos('nowPointActiveIndex', pointNum)
      this.lon =
        this.getPanoInfos[this.nowPanoActiveIndex].lon == 0
          ? 270
          : this.getPanoInfos[this.nowPanoActiveIndex].lon
      this.lat = this.getPanoInfos[this.nowPanoActiveIndex].lat
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      var r = this.resData[this.nowFloor].panos[this.nowPanoActiveIndex]
        .physicalFile.filePath
      var urls = [
        r + '/l1_r_1_1.jpg',
        r + '/l1_l_1_1.jpg',
        r + '/l1_u_1_1.jpg',
        r + '/l1_d_1_1.jpg',
        r + '/l1_f_1_1.jpg',
        r + '/l1_b_1_1.jpg'
      ]
      var textureCube = new THREE.CubeTextureLoader().load(urls, function () {
        _this.updateView()
      })
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      this.panoGroup.children[0].material.uniforms.texture.value = textureCube
    },
    changePanoMatByFloor(num, now) {
      const _this = this
      this.$parent.changePanoEditInfos('nowPanoActiveIndex', num)
      if (this.resData.length > 0 && this.resData[now].panos.length > 0) {
        var id = this.resData[now].panos[num].id
        var pointNum = this.getPointInfos.findIndex((item) => item.id === id)
        this.$parent.changePanoEditInfos('nowPointActiveIndex', pointNum)
        this.lon = 270
        this.lat = 0
        this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
        var r = this.resData[now].panos[num].physicalFile.filePath
        var urls = [
          r + '/l1_r_1_1.jpg',
          r + '/l1_l_1_1.jpg',
          r + '/l1_u_1_1.jpg',
          r + '/l1_d_1_1.jpg',
          r + '/l1_f_1_1.jpg',
          r + '/l1_b_1_1.jpg'
        ]
        var textureCube = new THREE.CubeTextureLoader().load(urls, function () {
          _this.updateView()
        })
        textureCube.format = THREE.RGBFormat
        textureCube.mapping = THREE.CubeRefractionMapping
        this.panoGroup.children[0].material.uniforms.texture.value = textureCube

        this.first[0] = this.resData[now].panos[num].fovMin
        console.log(this.resData[now].panos)
        this.first[1] = this.resData[now].panos[num].fovDefault
        this.first[2] = this.resData[now].panos[num].fovMax
        this.firstCommon = JSON.parse(JSON.stringify(this.first))
        this.firstx[0] = Math.floor((this.first[0] * 188) / 179)
        this.firstx[1] = Math.floor((this.first[1] * 188) / 179)
        this.firstx[2] = Math.floor((this.first[2] * 188) / 179)

        this.second[0] = this.resData[now].panos[num].v_Low
        this.second[1] = this.resData[now].panos[num].v_High
        this.secondCommon = JSON.parse(JSON.stringify(this.second))
        this.secondx[0] = Math.floor((this.second[0] * 188) / 181 + 95)
        this.secondx[1] = Math.floor((this.second[1] * 188) / 181 + 95)
        this.lon =
          this.resData[now].panos[num].lon == 0
            ? 270
            : this.resData[now].panos[num].lon
        this.lat = this.resData[now].panos[num].lat
        this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
        this.cameraUpdate()

        this.panoGroup.visible = true
      } else {
        this.panoGroup.visible = false
      }
    },
    posObj(obj, cam, r, lon, lat, h) {
      lat = Math.max(-85, Math.min(85, lat))
      var phi = THREE.Math.degToRad(90 - lat)
      var theta = THREE.Math.degToRad(lon)
      obj.position.x = r * Math.sin(phi) * Math.cos(theta) + cam.position.x
      obj.position.y = r * Math.cos(phi) + cam.position.y
      obj.position.z = r * Math.sin(phi) * Math.sin(theta) + cam.position.z
    },
    generatePano(panoGroup, data) {
      var r = data.physicalFile.filePath
      var urls = [
        r + '/l1_r_1_1.jpg',
        r + '/l1_l_1_1.jpg',
        r + '/l1_u_1_1.jpg',
        r + '/l1_d_1_1.jpg',
        r + '/l1_f_1_1.jpg',
        r + '/l1_b_1_1.jpg'
      ]

      const _this = this
      var textureCube = new THREE.CubeTextureLoader().load(urls, function () {
        _this.updateView()
      })
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      var planeUniforms = {
        cPosition: { value: new THREE.Vector3(0, 0, 0) },
        texture: { value: textureCube },
        ...THREE.UniformsLib.lights
      }
      var cubeMat = new THREE.ShaderMaterial({
        uniforms: planeUniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        lights: true
      })
      cubeMat.needsUpdate = true

      // var geometry = new THREE.BoxBufferGeometry(5000, 5000, 5000)
      var geometry = new THREE.SphereBufferGeometry(5000, 32, 32)
      geometry.scale(1, 1, -1)
      var cubeMesh = new THREE.Mesh(geometry, cubeMat)
      cubeMesh.visible = true
      cubeMesh.name = data.physicalFile.fileName
      panoGroup.add(cubeMesh)

      this.first[0] = this.resData[this.nowFloor].panos[
        this.nowPanoActiveIndex
      ].fovMin
      console.log(this.resData[this.nowFloor].panos)
      this.first[1] = this.resData[this.nowFloor].panos[
        this.nowPanoActiveIndex
      ].fovDefault
      this.first[2] = this.resData[this.nowFloor].panos[
        this.nowPanoActiveIndex
      ].fovMax
      this.firstCommon = JSON.parse(JSON.stringify(this.first))
      this.firstx[0] = Math.floor((this.first[0] * 188) / 179)
      this.firstx[1] = Math.floor((this.first[1] * 188) / 179)
      this.firstx[2] = Math.floor((this.first[2] * 188) / 179)

      this.second[0] = this.resData[this.nowFloor].panos[
        this.nowPanoActiveIndex
      ].v_Low
      this.second[1] = this.resData[this.nowFloor].panos[
        this.nowPanoActiveIndex
      ].v_High
      this.secondCommon = JSON.parse(JSON.stringify(this.second))
      this.secondx[0] = Math.floor((this.second[0] * 188) / 181 + 95)
      this.secondx[1] = Math.floor((this.second[1] * 188) / 181 + 95)
      this.lon =
        this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].lon == 0
          ? 270
          : this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].lon
      this.lat = this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].lat
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      this.cameraUpdate()
    },
    onresize() {
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.camera.aspect = this.containerW / this.containerH
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.containerW, this.containerH)
    },
    render() {
      this.renderer.render(this.scene, this.camera)
    },
    animate() {
      var delta = this.clock.getDelta()
      this.camera.lookAt(this.targetBox.position)
      this.rafId = requestAnimationFrame(this.animate)
      TWEEN.update()
      this.render()
    },

    seekAngle(x, y, z) {
      var r = Math.sqrt(x * x + y * y + z * z)
      var phi = Math.acos(y / r)
      var theta = Math.atan(z / x)
      var lon
      if (x >= 0) {
        lon = (theta * 180) / Math.PI
      } else {
        lon = 180 + (theta * 180) / Math.PI
      }

      var lat = 90 - (phi * 180) / Math.PI
      return [lon, lat]
    },

    getXY(posx, posy, poz) {
      const pos = new THREE.Vector3(posx, posy, poz)
      const vector = pos.project(this.camera)
      const halfWidth = this.containerW / 2
      const halfHeight = this.containerH / 2
      return {
        x: Math.round(vector.x * halfWidth + halfWidth) - 33,
        y: Math.round(-vector.y * halfHeight + halfHeight) - 33
      }
    },
    closePic() {
      this.dialogPic = false
    },
    addPic(data) {
      if (this.point.type == '3') {
        for (let i = 0; i < data.length; i++) {
          let isSame = false
          for (let j = 0; j < this.point.picArr.length; j++) {
            if (data[i].id == this.point.picArr[j].id) {
              isSame = true
              break
            }
          }
          if (!isSame) {
            this.point.picArr.push(data[i])
          }
        }
      } else {
        for (let i = 0; i < data.length; i++) {
          let isSame = false
          for (let j = 0; j < this.point.videoArr.length; j++) {
            if (data[i].id == this.point.videoArr[j].id) {
              isSame = true
              break
            }
          }
          if (!isSame) {
            this.point.videoArr.push(data[i])
          }
        }
      }
    },
    delPic(i) {
      if (this.point.type == '3') {
        this.point.picArr.splice(i, 1)
      } else {
        this.point.videoArr.splice(i, 1)
      }
    },
    moveFirst(ev, num) {
      const _this = this
      var oEvent = ev || event
      oEvent.preventDefault()
      var prePosX = oEvent.clientX
      var startX = _this.firstx[num]
      var nowLeft, offsetX
      var onMouseMove = function (ev) {
        var oEvent = ev || event
        offsetX = oEvent.clientX - prePosX
        nowLeft = offsetX + startX
        switch (num) {
          case 0:
            if (nowLeft >= 1 && nowLeft <= _this.firstx[1]) {
              _this.firstx[num] = nowLeft
              _this.first[num] = Math.ceil((nowLeft * 179) / 188)
              _this.firstCommon[num] = Math.ceil((nowLeft * 179) / 188)
            }
            break
          case 1:
            if (nowLeft >= _this.firstx[0] && nowLeft <= _this.firstx[2]) {
              _this.firstx[num] = nowLeft
              _this.first[num] = Math.ceil((nowLeft * 179) / 188)
              _this.firstCommon[num] = Math.ceil((nowLeft * 179) / 188)

              _this.cameraUpdate()
            }
            break
          case 2:
            if (nowLeft >= _this.firstx[1] && nowLeft <= 188) {
              _this.firstx[num] = nowLeft
              _this.first[num] = Math.ceil((nowLeft * 179) / 188)
              _this.firstCommon[num] = Math.ceil((nowLeft * 179) / 188)
            }
            break
          default:
            break
        }
      }
      document.addEventListener('mousemove', onMouseMove, false)
      var onMouseUp = function () {
        document.removeEventListener('mousemove', onMouseMove, false)
        document.removeEventListener('mouseup', onMouseUp, false)
      }

      document.addEventListener('mouseup', onMouseUp, false)
    },
    change1(num) {
      if (this.first[num] != '') {
        var x = Math.floor((this.first[num] * 188) / 179)
        switch (num) {
          case 0:
            if (x >= 1 && x <= this.firstx[1]) {
              this.firstx[num] = x
              this.firstCommon[num] = this.first[num]
            } else {
              this.first[num] = this.firstCommon[num]
            }
            break
          case 1:
            if (x >= this.firstx[0] && x <= this.firstx[2]) {
              this.firstx[num] = x
              this.firstCommon[num] = this.first[num]
            } else {
              this.first[num] = this.firstCommon[num]
            }
            this.cameraUpdate()
            break
          case 2:
            if (x >= this.firstx[1] && x <= 188) {
              this.firstx[num] = x
              this.firstCommon[num] = this.first[num]
            } else {
              this.first[num] = this.firstCommon[num]
            }
            break
          default:
            break
        }
      } else {
        this.first = JSON.parse(JSON.stringify(this.firstCommon))
      }
    },
    moveSecond(ev, num) {
      const _this = this
      var oEvent = ev || event
      oEvent.preventDefault()
      var prePosX = oEvent.clientX
      var startX = _this.secondx[num]
      var nowLeft, offsetX
      var onMouseMove = function (ev) {
        var oEvent = ev || event
        offsetX = oEvent.clientX - prePosX
        nowLeft = offsetX + startX
        switch (num) {
          case 0:
            if (nowLeft >= 1 && nowLeft <= _this.secondx[1]) {
              _this.secondx[num] = nowLeft
              _this.second[num] = Math.ceil(((nowLeft - 95) * 181) / 188)
              _this.secondCommon[num] = Math.ceil(((nowLeft - 95) * 181) / 188)
            }
            break
          case 1:
            if (nowLeft >= _this.secondx[0] && nowLeft <= 188) {
              _this.secondx[num] = nowLeft
              _this.second[num] = Math.ceil(((nowLeft - 95) * 181) / 188)
              _this.secondCommon[num] = Math.ceil(((nowLeft - 95) * 181) / 188)
            }
            break
          default:
            break
        }
      }
      document.addEventListener('mousemove', onMouseMove, false)
      var onMouseUp = function () {
        document.removeEventListener('mousemove', onMouseMove, false)
        document.removeEventListener('mouseup', onMouseUp, false)
      }

      document.addEventListener('mouseup', onMouseUp, false)
    },
    change2(num) {
      if (this.second[num] != '') {
        var x = Math.floor((this.second[num] * 188) / 181 + 95)
        switch (num) {
          case 0:
            if (x >= 1 && x <= this.secondx[1]) {
              this.secondx[num] = x
              this.secondCommon[num] = this.second[num]
            } else {
              this.second[num] = this.secondCommon[num]
            }
            break
          case 1:
            if (x >= this.secondx[1] && x <= 188) {
              this.secondx[num] = x
              this.secondCommon[num] = this.second[num]
            } else {
              this.second[num] = this.secondCommon[num]
            }
            break
          default:
            break
        }
      } else {
        this.second = JSON.parse(JSON.stringify(this.secondCommon))
      }
    },
    reset() {
      this.firstx = {
        0: 42,
        1: 68,
        2: 94
      }
      this.firstCommon = {
        0: 40,
        1: 65,
        2: 90
      }
      this.first = {
        0: 40,
        1: 65,
        2: 90
      }
      this.secondx = {
        0: 1,
        1: 188
      }
      this.secondCommon = {
        0: 1,
        1: 188
      }
      this.second = {
        0: -90,
        1: 90
      }

      this.lon = 270
      this.lat = 0
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      this.cameraUpdate()
      //this.updateView();
    },
    updateView() {
      this.renderer.render(this.scene, this.camera)
      const _this = this
      const left = _this.container.getElementsByClassName('view-frame')[0]
        .offsetLeft
      const top = _this.container.getElementsByClassName('view-frame')[0]
        .offsetTop
      const url = this.container
        .getElementsByTagName('canvas')[0]
        .toDataURL('image/jpeg', 0.3)
      const img = new Image()
      img.src = url
      img.onload = function () {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = 600
        canvas.height = 330
        ctx.drawImage(img, left, top, 600, 330, 0, 0, 600, 330)
        const dataURL = canvas.toDataURL('image/jpeg')
        _this.viewUrl = dataURL
      }
    },
    saveView() {
      this.updateView()
      this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].lon = this.lon
      this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].lat = this.lat
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onresize, false)
    cancelAnimationFrame(this.rafId)
    this.renderer.dispose()
    this.renderer.forceContextLoss()
    this.renderer.domElement = null
    this.renderer = null
    this.scene = null
    this.camera = null
    this.rafId = null
    this.container = null
    this.mesh = null
    this.controls = null
    this.modelInfo = null
  }
}
</script>
